import { cartClient } from '../common/cartClient';
import type {
  CreatePaymentIntentRequest,
  CreatePaymentIntentResponse,
  UpdatePaymentIntentRequest,
  UpdatePaymentIntentResponse,
} from './utils/types';

export const paymentAPIClient = {
  /**
   * Create Stripe payment intent
   */
  createPaymentIntent: async (params: CreatePaymentIntentRequest): Promise<CreatePaymentIntentResponse> =>
    cartClient.post('/payment/stripe/paymentIntent', params).then((res) => res.data),
  updatePaymentIntent: async (params: UpdatePaymentIntentRequest): Promise<UpdatePaymentIntentResponse> =>
    cartClient.put('/payment/stripe/paymentIntent', params).then((res) => res.data),
  // fetch('/api/checkout-sessions', {
  //   method: 'POST',
  //   body: JSON.stringify(params),
  // })
  //   .then((response) => response.json())
  //   .then((json) => json.checkoutSessionClientSecret),
};
